var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    fill: "none",
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_42",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_42)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0a5ec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M21.52 17.25h1.21m-14.105 0h8.542M8.625 9.875h14.75M30.75 5v17.115a3.75 3.75 0 0 1-3.75 3.75H13.994c-.31 0-.607.123-.825.341l-4.035 4.035a1.738 1.738 0 0 1-2.967-1.23v-1.98c0-.644-.523-1.166-1.167-1.166a3.75 3.75 0 0 1-3.75-3.75V5A3.75 3.75 0 0 1 5 1.25h22A3.75 3.75 0 0 1 30.75 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleText);
export default __webpack_public_path__ + "static/media/bubble-text.3a21a1bf9e008be8cb042b32a7fb0e7f.svg";
export { ForwardRef as ReactComponent };